/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { getConfig } from 'blb-utils/config';
import { baseRequest, axiosDefaults } from './baseRequest';
import { openUrlInSameTab } from 'blb-utils/misc';
import { clearAllAuthedUsers, createAxiosRequestWithSecondaryAuthSupport } from 'blb-utils/secondaryAuth';
const baseRoute = '/api/internal/auth';

// the csrf token is received after a successful call to /app-config
// if csrf token exists then intercept all outgoing req and add the token
baseRequest.interceptors.request.use(config => {
  if (getConfig()) {
    const {
      csrfToken
    } = getConfig();
    // headers are never undefined on our base request
    config.headers['x-csrf-token'] = csrfToken;
  }
  return config;
});
export const ping = () => baseRequest.post(`${baseRoute}/ping`);
export const touch = () => baseRequest.post(`${baseRoute}/touch`);
export const login = async loginBody => baseRequest.post(`${baseRoute}/login`, loginBody);
export const redirectToIdentityLoginUI = (search, relayState) => {
  const urlParams = new URLSearchParams(search);
  if (relayState) {
    urlParams.set('relayState', relayState);
  }
  openUrlInSameTab(`${baseRoute}/login?${urlParams.toString()}`);
};
export const logout = () => {
  // When a user logs out, both primary and secondary sessions should be cleared.
  clearAllAuthedUsers();
  openUrlInSameTab(`${baseRoute}/logout`);
};
export const resendEmailMFAChallenge = () => baseRequest.post(`${baseRoute}/resend-email-mfa`);
export const respondToAuthChallenge = async challengeBody => baseRequest.post(`${baseRoute}/challenge`, challengeBody);
export const forgotPassword = async newPassword => baseRequest.post(`${baseRoute}/reset-password/initiate`, newPassword);
export const confirmNewPassword = async confirmPasswordBody => baseRequest.post(`${baseRoute}/reset-password/confirm`, confirmPasswordBody);
export const baseRequestWithoutRedirect = createAxiosRequestWithSecondaryAuthSupport(axiosDefaults);
export const getMe = async () => baseRequestWithoutRedirect.get(`${baseRoute}/me`);